/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.15
 */
let { Circle } = L;
/**
 * 
 */
export default Circle.extend({
  /**
   * 原L.Circle在非经纬度等间隔投影的情况下是椭圆
   * 确保是圆形，用于标绘，但实际上是推荐的，因为半径已经不算是实际的半径
   */
  _updateBounds: function () {
    this._radius = this._radiusY;
    Circle.prototype._updateBounds.call(this);
  }
})
/**
 * 
 */
Circle.include({
  /**
   * 
   */
  toGeoJSON() {
    let { lat, lng } = this.getLatLng();
    this.options.radius = this._mRadius;
    return {
      type: 'Feature',
      properties: {},
      geometry: { coordinates: [lng, lat], type: 'Circle' }
    }
  }
})


// WEBPACK FOOTER //
// ./src/marker/Circle.js